/**
 * @generated SignedSource<<4414c3ac9cd9b831f024c922d51099ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "vendorId",
        "variableName": "accountId"
      },
      {
        "kind": "Literal",
        "name": "visibility",
        "value": 2
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "stage": 1
      }
    }
  ],
  "concreteType": "VppRtsConnection",
  "kind": "LinkedField",
  "name": "vppRTsByVppId",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "vppRTsByVppId(condition:{\"stage\":1})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorPendingActionIconQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VppTsConnection",
        "kind": "LinkedField",
        "name": "allVppTs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorPendingActionIconQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VppTsConnection",
        "kind": "LinkedField",
        "name": "allVppTs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "909139d89c3aa7fa7c20209113890aec",
    "id": null,
    "metadata": {},
    "name": "VendorPendingActionIconQuery",
    "operationKind": "query",
    "text": "query VendorPendingActionIconQuery(\n  $accountId: UUID!\n) {\n  allVppTs(condition: {vendorId: $accountId, visibility: 2}) {\n    nodes {\n      vppRTsByVppId(condition: {stage: 1}) {\n        totalCount\n      }\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "3a67751cf2832b91ea13ff3ee9173b9f";

module.exports = node;
